import { THEME } from '../../utils/theme';

const BarChart = ({ data, maxValue, height = 140 }) => {
  const max = maxValue || Math.max(...data.map(d => d.value), 1);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', height, padding: '0 4px' }}>
      {data.map((item, i) => (
        <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
          <div style={{ width: '100%', maxWidth: '40px', height: `${Math.max((item.value / max) * height * 0.8, 4)}px`, background: item.color, borderRadius: '4px 4px 0 0', transition: 'height 0.3s ease' }} title={`${item.label}: ${item.value}`} />
          <span style={{ fontSize: '10px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '0.3px' }}>{item.label}</span>
          <span style={{ fontSize: '13px', color: item.color, fontWeight: '600' }}>{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default BarChart;
